module.exports = __webpack_public_path__ + "img/1481023375.4a07043b.jpg";